import type { TreeNode } from 'tree-model';

import type { AssetsGetShareSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/assets';

import type { TreeReducerModel } from '../../ducks/tree/types';

export const hasSharedCollectionTreeChildren = (
  treeRoot: TreeNode<TreeReducerModel>,
  sharedCollectionId: string,
) => {
  const sharedCollectionNode = treeRoot.first(
    (node) => node.model.id === sharedCollectionId,
  );
  return Boolean(
    sharedCollectionNode?.children && sharedCollectionNode?.children.length,
  );
};

export const withSharedCollectionTitle = (
  model: TreeReducerModel,
  share: AssetsGetShareSchemaWithIdNullable,
) =>
  model.id === share.object_id && share.title
    ? { ...model, title: share.title }
    : model;
